

















































































































































































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'SmartTrack',
})
export default class SmartTrack extends Vue {
  baseUrl = process.env.VUE_APP_API_URL;

  requestFields = [
    {
      name: 'pro',
      type: 'string',
      required: true,
      length: '50',
      description: 'PRO # for a shipment',
    },
    {
      name: 'scac',
      type: 'string',
      required: true,
      length: '4',
      description: 'Carrier SCAC code',
    },
    {
      name: 'origZip',
      type: 'string',
      required: true,
      length: '10',
      description: 'Origin ZIP code',
    },
    {
      name: 'destZip',
      type: 'string',
      required: true,
      length: '10',
      description: 'Destination ZIP code',
    },
    {
      name: 'accountId',
      type: 'string',
      required: true,
      length: '20',
      description: 'Account ID',
    },
    {
      name: 'makeAvailableInSmartTrack',
      type: 'boolean',
      required: true,
      length: '-',
      description:
        'If true, the shipment will be made available in the SmartTrack website. If false, the API will just return the current state of the shipment.',
    },
  ];

  responseFields = [
    {
      name: 'notifications',
      type: 'array',
      required: false,
      length: '-',
      description: 'Array of notification messages related to the shipment',
    },
    {
      name: 'statusUpdates',
      type: 'array',
      required: true,
      length: '-',
      description: 'Array of status update objects for the shipment',
    },
    {
      name: 'statusUpdates[].location',
      type: 'object',
      required: true,
      length: '-',
      description: 'Location information for the status update',
    },
    {
      name: 'statusUpdates[].carrierSCAC',
      type: 'string',
      required: true,
      length: '4',
      description: 'Carrier SCAC code',
    },
    {
      name: 'statusUpdates[].dateTimeStamp',
      type: 'string',
      required: true,
      length: '20',
      description: 'Date and time of the status update',
    },
    {
      name: 'statusUpdates[].shipmentStatus',
      type: 'number',
      required: true,
      length: '-',
      description: 'Status code of the shipment',
    },
    {
      name: 'statusUpdates[].description',
      type: 'string',
      required: true,
      length: '50',
      description: 'Description of the status update',
    },
    {
      name: 'shipper',
      type: 'object',
      required: true,
      length: '-',
      description: 'Information about the shipper',
    },
    {
      name: 'consignee',
      type: 'object',
      required: true,
      length: '-',
      description: 'Information about the consignee',
    },
    {
      name: 'ladingExceptions',
      type: 'array',
      required: false,
      length: '-',
      description: 'Array of lading exceptions',
    },
    {
      name: 'carrierSCAC',
      type: 'string',
      required: true,
      length: '4',
      description: 'Carrier SCAC code',
    },
    {
      name: 'proNumber',
      type: 'string',
      required: true,
      length: '50',
      description: 'PRO number of the shipment',
    },
    {
      name: 'poNumber',
      type: 'string',
      required: false,
      length: '50',
      description: 'Purchase order number',
    },
    {
      name: 'bolNumber',
      type: 'string',
      required: false,
      length: '50',
      description: 'Bill of lading number',
    },
    {
      name: 'reference',
      type: 'object',
      required: false,
      length: '-',
      description: 'Reference information',
    },
    {
      name: 'customerRefNumber',
      type: 'string',
      required: false,
      length: '100',
      description: 'Customer reference number',
    },
    {
      name: 'pickupDate',
      type: 'string',
      required: false,
      length: '10',
      description: 'Date of pickup',
    },
    {
      name: 'pickupTime',
      type: 'string',
      required: false,
      length: '5',
      description: 'Time of pickup',
    },
    {
      name: 'deliveryDate',
      type: 'string',
      required: false,
      length: '10',
      description: 'Date of delivery',
    },
    {
      name: 'deliveryTime',
      type: 'string',
      required: false,
      length: '5',
      description: 'Time of delivery',
    },
  ];
}
